import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    countries: [],
    country: {},
    states: [],
    cities: [],
    pagination: {},
  },
  actions,
  mutations,
  getters,
};
